import React from 'react'

import Container from './Container'
import { Provider } from './Provider'
import type { Props } from './types'

export const Main = React.forwardRef<HTMLDivElement, Props>(
  (props: Props, ref) => {
    return (
      <Provider props={props} ref={ref}>
        <Container />
      </Provider>
    )
  },
)
